import { makeAutoObservable } from 'mobx';
import { ResultDialogProps } from 'components/Dialog/ResultDialog';

class Dialog {
    open = false;
    type: 'success' | 'error' = 'success';
    title = '';
    text = '';
    content?: React.ReactNode = null;
    confirmText = 'OK';
    hideClose = false;
    onClose?: () => void;

    constructor() {
        makeAutoObservable(this);
    }

    success(props: Omit<ResultDialogProps, 'open' | 'type'>) {
        this.open = true;
        this.title = props.title;
        this.confirmText = props.confirmText || 'OK';
        this.hideClose = props.hideClose || false;
        this.content = props.content;
        this.onClose = () => {
            this.open = false;
            props.onClose?.();
        };
    }

    error(props: Omit<ResultDialogProps, 'open' | 'type'>) {
        this.open = true;
        this.title = props.title;
        this.content = props.content;
        this.confirmText = props.confirmText || 'OK';
        this.hideClose = props.hideClose || false;
        this.onClose = () => {
            this.open = false;
            props.onClose?.();
        };
    }

    close() {
        this.open = false;
    }
}

const resultDialog = new Dialog();
export default resultDialog;
